__turbopack_context__.v({
  "background": "Modal-module__Xk1cAG__background",
  "close": "Modal-module__Xk1cAG__close",
  "closeButton": "Modal-module__Xk1cAG__closeButton",
  "container": "Modal-module__Xk1cAG__container",
  "content": "Modal-module__Xk1cAG__content",
  "header": "Modal-module__Xk1cAG__header",
  "large": "Modal-module__Xk1cAG__large",
  "medium": "Modal-module__Xk1cAG__medium",
  "modal": "Modal-module__Xk1cAG__modal",
  "small": "Modal-module__Xk1cAG__small",
  "title": "Modal-module__Xk1cAG__title",
  "zoom-in": "Modal-module__Xk1cAG__zoom-in",
  "zoomIn": "Modal-module__Xk1cAG__zoomIn",
});
